const IDTypeList = [
  { label: "大陆居民身份证", value: 1 },
  { label: "中国护照", value: 2 },
  { label: "香港居民往来内地通行证", value: 3 },
  { label: "澳门居民往来内地通行证", value: 4 },
  { label: "台湾居民往来内地通行证", value: 5 },
  { label: "香港居民居住证", value: 6 },
  { label: "澳门居民居住证", value: 7 },
  { label: "台湾居民居住证", value: 8 }
];

const positionTypeList = [
  { label: "外卖人员", value: "外卖人员" },
  { label: "快递人员", value: "快递人员" },
  { label: "家政人员", value: "家政人员" },
  { label: "网约车司机", value: "网约车司机" },
  { label: "网络货运司机", value: "网络货运司机" },
  { label: "代驾司机", value: "代驾司机" },
  { label: "其他", value: "其他" }
];

const IDType = new Map([
  [1, "大陆居民身份证"],
  [2, "中国护照"],
  [3, "香港居民往来内地通行证"],
  [4, "澳门居民往来内地通行证"],
  [5, "台湾居民往来内地通行证"],
  [6, "香港居民居住证"],
  [7, "澳门居民居住证"],
  [8, "台湾居民居住证"]
]);
const colors = new Map([
  ["success", "#03a113"],
  ["error", "#ff4d4f"],
  ["active", "#1890ff"],
  ["abnormal", "#303133"],
  ["warning", "#F59A23"]
]);
const positionTypeInfoList = [
  { label: "外卖人员", value: 1 },
  { label: "快递人员", value: 2 },
  { label: "家政人员", value: 3 },
  { label: "网约车司机", value: 4 },
  { label: "网络货运司机", value: 5 },
  { label: "代驾司机", value: 6 },
  { label: "直播人员", value: 7 },
  { label: "其他", value: 8 }
];
const otherPositionTypeInfoList = [
  { label: "外卖人员", value: "外卖人员" },
  { label: "快递人员", value: "快递人员" },
  { label: "家政人员", value: "家政人员" },
  { label: "网约车司机", value: "网约车司机" },
  { label: "网络货运司机", value: "网络货运司机" },
  { label: "代驾司机", value: "代驾司机" },
  { label: "直播人员", value: "直播人员" },
  { label: "其他", value: "其他" }
];

const payeeBankTypeList = [
  { label: "到卡", value: 1 },
  { label: "到户", value: 3 }
];

const payeeBankType = new Map([[1, "到卡", 3, "到户"]]);
const map = {
  IDType,
  colors,
  payeeBankType
};
// 人岗签约状态
export const contractStatus = [
  { label: "未签署", value: 0 },
  { label: "签署中", value: 1 },
  { label: "已签署", value: 2 },
  { label: "已解约", value: 3 }
];
const qualificationTypeList = [
  {
    label: "小学",
    value: "0"
  },
  {
    label: "初中",
    value: "1"
  },
  {
    label: "高中",
    value: "2"
  },
  {
    label: "中专",
    value: "3"
  },
  {
    label: "专科",
    value: "4"
  },
  {
    label: "本科",
    value: "5"
  },
  {
    label: "硕士",
    value: "6"
  },
  {
    label: "博士",
    value: "7"
  },
  {
    label: "其他",
    value: "8"
  }
];
export const emergencyContactRelaList = [
  { label: "配偶", value: "配偶" },
  { label: "子女", value: "子女" },
  { label: "父母", value: "父母" },
  { label: "兄妹", value: "兄妹" },
  { label: "同事", value: "同事" },
  { label: "其他亲属", value: "其他亲属" },
  { label: "朋友", value: "朋友" },
  { label: "监护人", value: "监护人" },
  { label: "其他", value: "其他" }
];
export default {
  IDTypeList,
  positionTypeList,
  map,
  positionTypeInfoList,
  contractStatus,
  otherPositionTypeInfoList,
  qualificationTypeList,
  emergencyContactRelaList,
  payeeBankTypeList
};
